const MoveTo = require("moveto");
const moveTo = new MoveTo();

export const smoothScroll = () => {
  const buttons = document.querySelectorAll("[data-moveto]");
  buttons.forEach((button) => {
    moveTo.registerTrigger(button);
  });
};
